export default "__VITE_ASSET__3a1e525d__"